(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmo-hero"] && !Shopify.designMode) return;
  try {
    
class MmoHero extends HTMLElement {
  connectedCallback() {
    this.intro();
    this.oil();
    if (window.MMO) MMO.magnetise(this);
  }
  intro() {
    const intro = this.querySelector('[data-intro]');
    if (!intro) return;
    const skip = sessionStorage.getItem('mmo-intro') ||
                 (window.MMO && MMO.reduced) ||
                 (window.Shopify && Shopify.designMode);
    if (skip) { intro.remove(); return; }
    sessionStorage.setItem('mmo-intro', '1');
    setTimeout(() => intro.classList.add('is-done'), 2600);
    setTimeout(() => intro.remove(), 3600);
  }
  oil() {
    const canvas = this.querySelector('[data-canvas]');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const palette = [[198,148,71],[157,174,155],[232,203,197],[198,148,71]];
    const total = (window.MMO && MMO.reduced) ? 5 : parseInt(canvas.dataset.blobs || '13', 10);
    let blobs = [], raf = null;
    const pointer = { x: -9999, y: -9999 };

    const resize = () => {
      const dpr = Math.min(devicePixelRatio || 1, 2);
      canvas.width = canvas.offsetWidth * dpr;
      canvas.height = canvas.offsetHeight * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    const seed = () => {
      blobs = Array.from({ length: total }, (_, i) => {
        const c = palette[i % palette.length];
        return {
          x: Math.random() * canvas.offsetWidth,
          y: Math.random() * canvas.offsetHeight,
          r: 110 + Math.random() * 230,
          vx: (Math.random() - 0.5) * 0.32,
          vy: (Math.random() - 0.5) * 0.32,
          rgb: `rgba(${c[0]},${c[1]},${c[2]},`
        };
      });
    };
    const draw = () => {
      const w = canvas.offsetWidth, h = canvas.offsetHeight;
      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';
      for (const b of blobs) {
        b.x += b.vx; b.y += b.vy;
        if (b.x < -b.r) b.x = w + b.r; else if (b.x > w + b.r) b.x = -b.r;
        if (b.y < -b.r) b.y = h + b.r; else if (b.y > h + b.r) b.y = -b.r;
        let px = b.x, py = b.y;
        const dx = b.x - pointer.x, dy = b.y - pointer.y, d = Math.hypot(dx, dy);
        if (d < 260 && d > 0) { const f = (260 - d) / 260 * 60; px += dx / d * f; py += dy / d * f; }
        const g = ctx.createRadialGradient(px, py, 0, px, py, b.r);
        g.addColorStop(0, b.rgb + '0.30)');
        g.addColorStop(0.55, b.rgb + '0.10)');
        g.addColorStop(1, b.rgb + '0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(px, py, b.r, 0, Math.PI * 2); ctx.fill();
      }
      ctx.globalCompositeOperation = 'source-over';
      raf = requestAnimationFrame(draw);
    };

    this.addEventListener('mousemove', (e) => {
      const r = canvas.getBoundingClientRect();
      pointer.x = e.clientX - r.left; pointer.y = e.clientY - r.top;
    }, { passive: true });
    this.addEventListener('mouseleave', () => { pointer.x = pointer.y = -9999; });
    addEventListener('resize', () => { resize(); seed(); });

    resize(); seed();
    const start = () => { if (!raf) draw(); };
    const stop = () => { if (raf) { cancelAnimationFrame(raf); raf = null; } };
    window.MMO ? MMO.whileVisible(canvas, start, stop) : start();
  }
}
if (!customElements.get('mmo-hero')) customElements.define('mmo-hero', MmoHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmo-ingredients"] && !Shopify.designMode) return;
  try {
    
class MmoIngredients extends HTMLElement {
  connectedCallback() {
    const items = [...this.querySelectorAll('[data-item]')];
    const stages = [...this.querySelectorAll('[data-stage]')];
    if (!items.length) return;
    const activate = (i) => {
      items.forEach((el, n) => el.classList.toggle('is-active', n === i));
      stages.forEach((el, n) => el.classList.toggle('is-active', n === i));
    };
    items.forEach((el, i) => {
      ['mouseenter', 'focus', 'click'].forEach((evt) => el.addEventListener(evt, () => activate(i)));
    });
  }
}
if (!customElements.get('mmo-ingredients')) customElements.define('mmo-ingredients', MmoIngredients);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmo-products-grid"] && !Shopify.designMode) return;
  try {
    
class MmoProductGrid extends HTMLElement {
  connectedCallback() {
    this.drawer = this.querySelector('[data-drawer]');
    this.scrim = this.querySelector('[data-scrim]');
    this.body = this.querySelector('[data-body]');

    this.bindTabs();
    this.bindTilt();
    this.bindClicks();
    if (window.MMO && MMO.magnetise) MMO.magnetise(this);

    if (this.drawer) {
      this.querySelector('[data-close]').addEventListener('click', () => this.close());
      this.scrim.addEventListener('click', () => this.close());
      this.onKey = (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) this.close();
      };
      document.addEventListener('keydown', this.onKey);
    }
  }

  disconnectedCallback() {
    if (this.onKey) document.removeEventListener('keydown', this.onKey);
  }

  bindTabs() {
    this.tabs = [...this.querySelectorAll('[data-tab]')];
    this.panels = [...this.querySelectorAll('[data-panel]')];
    if (this.tabs.length < 2) return;

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i));

      // left/right arrows move between tabs, as expected of a tablist
      tab.addEventListener('keydown', (e) => {
        let next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
        if (e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = this.tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      });
    });
  }

  select(index) {
    const id = this.tabs[index].dataset.tab;

    this.tabs.forEach((tab, i) => {
      const on = i === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', String(on));
      tab.tabIndex = on ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.panel !== id;
    });

    // reveal animations only fire once, so make sure a freshly shown
    // panel is not stuck in its hidden state
    const active = this.panels.find((p) => p.dataset.panel === id);
    if (active) {
      active.querySelectorAll('mmo-reveal').forEach((el) => el.classList.add('is-visible'));
    }
  }

  bindTilt() {
    if ((window.MMO && MMO.reduced) || !matchMedia('(hover:hover)').matches) return;
    this.querySelectorAll('[data-tilt]').forEach((card) => {
      card.addEventListener('mousemove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = `perspective(900px) rotateY(${x * 7}deg) rotateX(${-y * 7}deg) translateY(-6px)`;
      });
      card.addEventListener('mouseleave', () => { card.style.transform = ''; });
    });
  }

  bindClicks() {
    this.addEventListener('click', (e) => {
      const quick = e.target.closest('[data-quick]');
      if (quick) {
        e.preventDefault();
        this.open(JSON.parse(quick.closest('[data-product]').dataset.product), quick);
        return;
      }
      const add = e.target.closest('[data-add]');
      if (add && window.MMO) {
        e.preventDefault();
        MMO.addToCart(add.dataset.add, add.dataset.title || 'Item', add).then(() => this.close());
      }
    });
  }

  open(data, trigger) {
    if (!this.drawer) return;
    this.trigger = trigger;
    this.body.innerHTML = `
      <div class="mmo-drawer__media">${data.image ? `<img src="${data.image}" alt="${data.title}" class="${data.contain ? 'is-contain' : ''}">` : ''}</div>
      ${data.kind ? `<p class="mmo-card__kind">${data.kind}</p>` : ''}
      <h3 class="mmo-h3">${data.title}</h3>
      <p class="mmo-drawer__price">${data.compare ? `<s>${data.compare}</s>` : ''}${data.price}</p>
      ${data.note ? `<p class="mmo-lede" style="font-size:15.5px">${data.note}</p>` : ''}
      ${data.bullets.length ? `<ul class="mmo-drawer__list">${data.bullets.map((b) => `<li>${b}</li>`).join('')}</ul>` : ''}
      <div class="mmo-drawer__cta">
        ${data.available ? `<button type="button" class="mmo-btn mmo-btn--dark mmo-btn--block" data-add="${data.variant}" data-title="${data.title}">Add to bag</button>` : ''}
        <a class="mmo-btn mmo-btn--outline mmo-btn--block" href="${data.url}">See full details</a>
      </div>`;
    this.drawer.classList.add('is-open');
    this.scrim.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    this.querySelector('[data-close]').focus();
  }

  close() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    this.scrim.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (this.trigger) this.trigger.focus();
  }
}

if (!customElements.get('mmo-product-grid')) {
  customElements.define('mmo-product-grid', MmoProductGrid);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmo-reccemmond-products"] && !Shopify.designMode) return;
  try {
    
class MmoRelatedGrid extends HTMLElement {
  connectedCallback() {
    this.drawer = this.querySelector('[data-drawer]');
    this.scrim = this.querySelector('[data-scrim]');
    this.body = this.querySelector('[data-body]');

    this.bindTilt();
    this.bindClicks();
    if (window.MMO && MMO.magnetise) MMO.magnetise(this);

    if (this.drawer) {
      this.querySelector('[data-close]').addEventListener('click', () => this.close());
      this.scrim.addEventListener('click', () => this.close());
      this.onKey = (e) => { if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) this.close(); };
      document.addEventListener('keydown', this.onKey);
    }
  }

  disconnectedCallback() { if (this.onKey) document.removeEventListener('keydown', this.onKey); }

  bindTilt() {
    if ((window.MMO && MMO.reduced) || !matchMedia('(hover:hover)').matches) return;
    this.querySelectorAll('[data-tilt]').forEach((card) => {
      card.addEventListener('mousemove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = `perspective(900px) rotateY(${x * 7}deg) rotateX(${-y * 7}deg) translateY(-6px)`;
      });
      card.addEventListener('mouseleave', () => { card.style.transform = ''; });
    });
  }

  bindClicks() {
    this.addEventListener('click', (e) => {
      const quick = e.target.closest('[data-quick]');
      if (quick) {
        e.preventDefault();
        this.open(JSON.parse(quick.closest('[data-product]').dataset.product), quick);
        return;
      }
      const add = e.target.closest('[data-add]');
      if (add && window.MMO) {
        e.preventDefault();
        MMO.addToCart(add.dataset.add, add.dataset.title || 'Item', add).then(() => this.close());
      }
    });
  }

  open(data, trigger) {
    if (!this.drawer) return;
    this.trigger = trigger;
    this.body.innerHTML = `
      <div class="mmo-drawer__media">${data.image ? `<img src="${data.image}" alt="${data.title}" class="${data.contain ? 'is-contain' : ''}">` : ''}</div>
      ${data.kind ? `<p class="mmo-card__kind">${data.kind}</p>` : ''}
      <h3 class="mmo-h3">${data.title}</h3>
      <p class="mmo-drawer__price">${data.compare ? `<s>${data.compare}</s>` : ''}${data.price}</p>
      ${data.note ? `<p class="mmo-lede" style="font-size:15.5px">${data.note}</p>` : ''}
      ${data.bullets.length ? `<ul class="mmo-drawer__list">${data.bullets.map((b) => `<li>${b}</li>`).join('')}</ul>` : ''}
      <div class="mmo-drawer__cta">
        ${data.available ? `<button type="button" class="mmo-btn mmo-btn--dark mmo-btn--block" data-add="${data.variant}" data-title="${data.title}">Add to bag</button>` : ''}
        <a class="mmo-btn mmo-btn--outline mmo-btn--block" href="${data.url}">See full details</a>
      </div>`;
    this.drawer.classList.add('is-open');
    this.scrim.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    this.querySelector('[data-close]').focus();
  }

  close() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    this.scrim.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (this.trigger) this.trigger.focus();
  }
}
if (!customElements.get('mmo-related-grid')) {
  customElements.define('mmo-related-grid', MmoRelatedGrid);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmo-scent-finder"] && !Shopify.designMode) return;
  try {
    
class MmoScentFinder extends HTMLElement {
  connectedCallback() {
    const source = this.querySelector('[data-scents]');
    try { this.data = JSON.parse(source.textContent); } catch (e) { return; }
    this.results = this.querySelector('[data-results]');
    this.answers = { audience: null, mood: null };

    this.querySelectorAll('[data-question]').forEach((group) => {
      const key = group.dataset.question;
      group.querySelectorAll('button').forEach((btn) => {
        btn.addEventListener('click', () => {
          group.querySelectorAll('button').forEach((b) => {
            b.classList.toggle('is-active', b === btn);
            b.setAttribute('aria-pressed', String(b === btn));
          });
          this.answers[key] = btn.dataset.value;
          this.render();
        });
      });
    });
  }
  render() {
    const { audience, mood } = this.answers;
    if (!audience || !mood) return;
    let matches = this.data.filter((s) => (audience === 'any' || s.audience === audience) && s.mood === mood);
    if (!matches.length) matches = this.data.filter((s) => audience === 'any' || s.audience === audience);
    if (!matches.length) {
      this.results.innerHTML = '<p class="mmo-finder__empty">No match yet — try another mood.</p>';
      return;
    }
    const row = (k, v) => v ? `<p class="mmo-scent__row"><span class="mmo-scent__key">${k}</span><span>${v}</span></p>` : '';
    this.results.innerHTML = matches.slice(0, 2).map((s) => `
      <article class="mmo-scent">
        <h3 class="mmo-scent__name">${s.name}</h3>
        <p class="mmo-scent__mood">${s.mood_label || ''}</p>
        ${row('Top', s.top)}${row('Heart', s.heart)}${row('Base', s.base)}
        ${s.url ? `<a class="mmo-arrow mmo-scent__cta" href="${s.url}">Shop this scent &rarr;</a>` : ''}
      </article>`).join('');
  }
}
if (!customElements.get('mmo-scent-finder')) customElements.define('mmo-scent-finder', MmoScentFinder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmo-signature-scent"] && !Shopify.designMode) return;
  try {
    
class MmoRippleFeature extends HTMLElement {
  connectedCallback() {
    if (window.MMO) MMO.magnetise(this);
    const canvas = this.querySelector('[data-canvas]');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const reduced = window.MMO && MMO.reduced;
    let rings = Array.from({ length: 9 }, (_, i) => ({ r: i * 72, a: 0.55 - i * 0.055 }));
    let tick = 0, raf = null;

    const resize = () => {
      const dpr = Math.min(devicePixelRatio || 1, 2);
      canvas.width = canvas.offsetWidth * dpr;
      canvas.height = canvas.offsetHeight * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    const draw = () => {
      const w = canvas.offsetWidth, h = canvas.offsetHeight;
      ctx.clearRect(0, 0, w, h);
      if (++tick % 46 === 0 && !reduced) rings.push({ r: 0, a: 0.55 });
      rings = rings.filter((ring) => {
        ring.r += 1.5; ring.a -= 0.0032;
        if (ring.a <= 0) return false;
        ctx.beginPath();
        ctx.strokeStyle = `rgba(198,148,71,${ring.a})`;
        ctx.lineWidth = 1;
        ctx.ellipse(w / 2, h / 2, ring.r, ring.r * 0.42, 0, 0, Math.PI * 2);
        ctx.stroke();
        return true;
      });
      raf = requestAnimationFrame(draw);
    };

    resize();
    addEventListener('resize', resize);
    const start = () => { if (!raf) draw(); };
    const stop = () => { if (raf) { cancelAnimationFrame(raf); raf = null; } };
    window.MMO ? MMO.whileVisible(canvas, start, stop) : start();
  }
}
if (!customElements.get('mmo-ripple-feature')) customElements.define('mmo-ripple-feature', MmoRippleFeature);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmo-story-reel"] && !Shopify.designMode) return;
  try {
    
class MmoStoryReel extends HTMLElement {
  connectedCallback() {
    this.rail = this.querySelector('[data-rail]');
    this.track = this.querySelector('[data-track]');
    this.bar = this.querySelector('[data-bar]');
    if (!this.rail || !this.track) return;

    if (window.MMO && MMO.magnetise) MMO.magnetise(this);

    this.active = false;
    this.ticking = false;
    this.distance = 0;

    this.onScroll = this.onScroll.bind(this);
    this.measure = this.measure.bind(this);

    // only run the scroll handler while the reel is on screen
    this.io = new IntersectionObserver((entries) => {
      this.active = entries[0].isIntersecting;
      if (this.active) this.update();
    }, { threshold: 0 });
    this.io.observe(this.rail);

    // re-measure when the layout changes (fonts, images, resize, editor edits)
    if ('ResizeObserver' in window) {
      this.ro = new ResizeObserver(this.measure);
      this.ro.observe(this.track);
      this.ro.observe(this.rail);
    }

    addEventListener('scroll', this.onScroll, { passive: true });
    addEventListener('resize', this.measure);

    // images change the track width once they load
    this.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', this.measure, { once: true });
    });

    // wait a frame so layout has settled before the first measurement
    requestAnimationFrame(this.measure);
  }

  disconnectedCallback() {
    removeEventListener('scroll', this.onScroll);
    removeEventListener('resize', this.measure);
    if (this.io) this.io.disconnect();
    if (this.ro) this.ro.disconnect();
  }

  get enabled() {
    return innerWidth > 900 && !(window.MMO && MMO.reduced);
  }

  measure() {
    if (!this.enabled) {
      this.track.style.transform = '';
      this.distance = 0;
      return;
    }
    // how far the track has to travel sideways
    this.distance = Math.max(this.track.scrollWidth - innerWidth, 0);
    this.update();
  }

  onScroll() {
    if (!this.active || this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => this.update());
  }

  update() {
    this.ticking = false;
    if (!this.enabled) { this.track.style.transform = ''; return; }

    const travel = this.rail.offsetHeight - innerHeight;
    if (travel <= 0 || this.distance <= 0) return;

    const top = this.rail.getBoundingClientRect().top;
    const progress = Math.min(Math.max(-top / travel, 0), 1);

    this.track.style.transform = 'translate3d(' + (-progress * this.distance) + 'px,0,0)';
    if (this.bar) this.bar.style.width = (progress * 100) + '%';
  }
}

if (!customElements.get('mmo-story-reel')) {
  customElements.define('mmo-story-reel', MmoStoryReel);
}

  } catch(e) { console.error(e); }
})();
})();
